import { atom } from "jotai";

export const chatbotOpenAtom = atom<boolean>(false);
